import api from './api';

export interface ProcessAlert {
  id: string;
  cnj_number: string;
  tribunal: string;
  label?: string;
  notes?: string;
  is_active: boolean;
  email_enabled: boolean;
  last_checked_at?: string;
  last_movement_count: number;
  last_movement_date?: string;
  created_at: string;
}

export interface ProcessAlertCreate {
  cnj_number: string;
  tribunal: string;
  label?: string;
  notes?: string;
  email_enabled?: boolean;
}

export interface ProcessAlertUpdate {
  label?: string;
  notes?: string;
  is_active?: boolean;
  email_enabled?: boolean;
}

export const listAlerts = async (): Promise<ProcessAlert[]> => {
  const res = await api.get('/process-alerts/');
  return res.data.data;
};

export const createAlert = async (body: ProcessAlertCreate): Promise<ProcessAlert> => {
  const res = await api.post('/process-alerts/', body);
  return res.data.data;
};

export const updateAlert = async (id: string, body: ProcessAlertUpdate): Promise<ProcessAlert> => {
  const res = await api.patch(`/process-alerts/${id}`, body);
  return res.data.data;
};

export const deleteAlert = async (id: string): Promise<void> => {
  await api.delete(`/process-alerts/${id}`);
};

export const checkAlertNow = async (id: string) => {
  const res = await api.post(`/process-alerts/check-now/${id}`);
  return res.data.data;
};

export const getAlertMovements = async (id: string) => {
  const res = await api.get(`/process-alerts/movements/${id}`);
  return res.data.data;
};
